module.exports = __webpack_public_path__ + "static/media/powertool.4c712250.jpeg";